import { useApp } from "@/hooks/use-app";
import GlobalLoading from "@/components/ui/modal/Loading";
import { useRouteNavigateHook } from "@/manager/manager/route-navigate-manager";

export function MiutaApp({
  children,
}: {
  children: React.ReactNode;
}) {
  useRouteNavigateHook.useInitialRouterI18nNavigate();

  const { loading } = useApp();
  // if (loading) {
  //   return <GlobalLoading />
  // }
  return children;
}
